export const CART_ITEM = 'CART_ITEM';
export const MENU_ITEM = 'MENU_ITEM';
